import Events from '@/domain/events/index';
import { getEventDetail } from '@/infra/events/eventRepository';

export async function getEvent({
  eventId,
}: Props): Promise<ResolvedEventDetailData> {
  try {
    const res = await getEventDetail({ eventId: eventId });
    const event = new Events(res.event);
    return event;
  } catch (error: any) {
    if (error.message === 'ServerError') {
      throw error;
    }
    throw error;
  }
}

export default getEvent;

export type ResolvedEventDetailData = Events;

interface Props {
  eventId: string;
}
